import { render, staticRenderFns } from "./CustomerUserSecurity.vue?vue&type=template&id=263f5636&"
import script from "./CustomerUserSecurity.vue?vue&type=script&lang=ts&"
export * from "./CustomerUserSecurity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports